if (!customElements.get('multi-collection')) {
  customElements.define(
    'multi-collection',
    class MultiCollection extends HTMLElement {
      constructor() {
        super();
        this.collectionTabFirst = this.querySelector('.col-tab-1');
        this.collectionTabSecond = this.querySelector('.col-tab-2');

        this.collectionTabFirst && this.collectionTabFirst.addEventListener('click', this.setCollectionFirst.bind(this));
        this.collectionTabSecond && this.collectionTabSecond.addEventListener('click', this.setCollectionSecond.bind(this));

        this.collectionListFirst = this.querySelector('.multi-collection-list-first');
        this.collectionListSecond = this.querySelector('.multi-collection-list-second');

        this.collectionLinkFirst = this.dataset.collectionFirst;
        this.collectionLinkSecond = this.dataset.collectionSecond;
        this.multicollectionLink = this.querySelector('.multi-collection-link');

        if (!this.dataset.config) return;
        this.config = JSON.parse(this.dataset.config);
      }

      connectedCallback() {
        this.initSwipers();
      }

      setCollectionFirst() {
        this.collectionTabFirst.classList.add('multi-collection-title-active');
        this.collectionTabSecond.classList.remove('multi-collection-title-active');
        this.collectionListFirst.classList.add('multi-collection-list--active');
        this.collectionListSecond.classList.remove('multi-collection-list--active');

        this.querySelector('.swiper-first-buttons').classList.add('swiper-buttons-active');
        this.querySelector('.swiper-second-buttons').classList.remove('swiper-buttons-active');
        this.querySelector('.swiper-pagination--first').classList.remove('hidden');
        this.querySelector('.swiper-pagination--second').classList.add('hidden');

        if (!this.collectionLinkFirst) return;
        if (Object.is(this.multicollectionLink, null)) return;
        this.multicollectionLink.href = this.collectionLinkFirst;
      }

      setCollectionSecond() {
        this.collectionTabFirst.classList.remove('multi-collection-title-active');
        this.collectionTabSecond.classList.add('multi-collection-title-active');
        this.collectionListFirst.classList.remove('multi-collection-list--active');
        this.collectionListSecond.classList.add('multi-collection-list--active');

        this.querySelector('.swiper-first-buttons').classList.remove('swiper-buttons-active');
        this.querySelector('.swiper-second-buttons').classList.add('swiper-buttons-active');

        this.querySelector('.swiper-pagination--second').classList.remove('hidden');
        this.querySelector('.swiper-pagination--first').classList.add('hidden');

        if (!this.collectionLinkSecond) return;
        if (Object.is(this.multicollectionLink, null)) return;
        this.multicollectionLink.href = this.collectionLinkSecond;
      }

      initSwipers() {
        const initSwiper = (container, nextButton, prevButton, customWrapperClass = 'swiper-wrapper', paginationEl) => {
          const swiperConfig = {};
          if (this.config?.dots) {
            swiperConfig.pagination = {
              el: paginationEl,
              clickable: true,
            };
          } else {
            swiperConfig.navigation = {
              nextEl: nextButton,
              prevEl: prevButton,
            };
          }

          return new Swiper(container, {
            loop: true,
            slidesPerView: 7,
            // centeredSlides: false,
            centerInsufficientSlides: true,
            speed: 600,
            // freeMode: true,
            wrapperClass: customWrapperClass,
            spaceBetween: 10,
            breakpoints: {
              350: {
                slidesPerView: 1.8,
                centerInsufficientSlides: false,
                centeredSlides: true,
              },
              768: {
                slidesPerView: 3,
                centerInsufficientSlides: true,
              },
              980: {
                slidesPerView: 5,
                centerInsufficientSlides: true,
              },
              1440: {
                slidesPerView: 6,
                centerInsufficientSlides: true,
              }
            },
           ...swiperConfig
          });
        };

        this.collectionSwiper = initSwiper(
          `.swiper-first-${this.dataset.sectionId}`,
          `.swiper-button-next-first-${this.dataset.sectionId}`,
          `.swiper-button-prev-first-${this.dataset.sectionId}`,
          `swiper-wrapper-${this.dataset.sectionId}`,
          '.swiper-pagination--first'
        );

        this.collectionSwiperSecond = initSwiper(
          `.swiper-second-${this.dataset.sectionId}`,
          `.swiper-button-next-second-${this.dataset.sectionId}`,
          `.swiper-button-prev-second-${this.dataset.sectionId}`,
          `swiper-wrapper-second-${this.dataset.sectionId}`,
          '.swiper-pagination--second'
        );
      }
    }
  );
}
